import React from 'react';
import './Textarea.scss';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', error, ...props }, ref) => {
    return (
      <div className="ui-textarea-wrapper">
        <textarea
          ref={ref}
          className={`ui-textarea ${error ? 'ui-textarea-error' : ''} ${className}`}
          {...props}
        />
        {error && <span className="ui-textarea-error-text">{error}</span>}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
